/**
 * <sb-theme-toggle><button>...</button></sb-theme-toggle>
 *
 * Progressive enhancement over a real <button> (see snippets/sb-theme-toggle.liquid):
 * the button is already visible and correctly labeled server-side, this just wires
 * up the click behavior and keeps aria state in sync if more than one instance is
 * on the page (desktop header + mobile menu).
 */
(function () {
  var STORAGE_KEY = 'sb-theme';

  function currentMode() {
    return document.documentElement.getAttribute('data-sb-theme') === 'light' ? 'light' : 'dark';
  }

  class SBThemeToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this._onSync = this._sync.bind(this);
      this._sync();
      this.button.addEventListener('click', this._onToggle.bind(this));
      window.addEventListener('sb:theme-change', this._onSync);
    }

    disconnectedCallback() {
      window.removeEventListener('sb:theme-change', this._onSync);
    }

    _sync() {
      var mode = currentMode();
      var next = mode === 'dark' ? 'light' : 'dark';
      this.button.setAttribute('aria-pressed', mode === 'light' ? 'true' : 'false');
      this.button.setAttribute('aria-label', 'Switch to ' + next + ' mode');
    }

    _onToggle() {
      var next = currentMode() === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-sb-theme', next);
      try {
        window.localStorage.setItem(STORAGE_KEY, next);
      } catch (e) {
        /* localStorage can throw in locked-down/private contexts — the
           toggle still works for the session, it just won't persist */
      }
      window.dispatchEvent(new CustomEvent('sb:theme-change'));
    }
  }

  customElements.define('sb-theme-toggle', SBThemeToggle);
})();
